<template>
  <div class="pos-rel" style="height: 700px">
    <div class="thumb-example">
      <!-- swiper1 -->
      <swiper
        class="swiper gallery-top"
        :options="swiperOptionTop"
        ref="swiperTop"
      >
        <swiper-slide class="slide-1" v-for="item in list" :key="item.id">
          <img :src="item.thumbUrl" style="height: 700px; width: 100%" alt="" />
          <div class="pos-abs" style="top: 10%; left: 10%">
            <div class="font-size-35 text-color-white">优秀广播剧</div>
            <div class="font-size-35 text-color-white">及IP作品展示</div>
          </div>
        </swiper-slide>
      </swiper>
      
      <swiper
        class="swiper gallery-thumbs"
        :options="swiperOptionThumbs"
        style="margin-top:-450px"
        ref="swiperThumbs"
      >
        <swiper-slide class="slide" v-for="item in list" :key="item.id">
          <div class="bg-white" style="padding:10px;border-radius:5px">
            <img
              :src="item.thumbUrl"
              style="width: 100%;"
              height="200px"
            />
            <div style="padding: 14px">
              <div class="font-size-14">单方面的付出让我精疲力竭</div>
              <div class="font-size-12">SIM工作室 {{ item.id }}</div>
              <div class="text-color-pink font-size-12 margin-t-20">
                预计2024-07-15日上线
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "good",
  components: {},
  data() {
    return {
      list: [
        {
          id: 0,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/01.png",
        },
        {
          id: 1,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/02.png",
        },
        {
          id: 2,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/03.png",
        },
        {
          id: 3,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          id: 4,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/01.png",
        },
        {
          id: 5,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/02.png",
        },
        {
          id: 6,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/03.png",
        },
        {
          id: 7,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/04.png",
        },
        {
          id: 8,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/01.png",
        },
        {
          id: 9,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/02.png",
        },
        {
          id: 10,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/03.png",
        },
        {
          id: 11,
          name: "《撒娇小狗最好命》",
          author: "蜜阅广播剧出品",
          desc: "U大学教学楼发生了重大火灾，浓厚的烟雾里面夹杂着慌张的人群脚步声还有机械的烟雾报警器声，有点功德的但不多的广播里面的机械提醒着",
          num: "11.7w",
          imgUrl: "/static/images/bg-good.png",
          thumbUrl: "/static/images/album/04.png",
        },
      ],
      swiperOptionTop: {
        zoom: true,
        loop: true,
        loopedSlides: 1, // looped slides should be the same
        spaceBetween: 20,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // autoplay: {  //自动轮播
        //   delay: 2000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 6, // looped slides should be the same
        spaceBetween: 20,
        centeredSlides: false,
        slidesPerView: 6,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const swiperTop = this.$refs.swiperTop.swiper;
        const swiperThumbs = this.$refs.swiperThumbs.swiper;
        swiperTop.controller.control = swiperThumbs;
        swiperThumbs.controller.control = swiperTop;
      }, 1000);
    });
  },
};
</script>
  
  <style scoped>
.swiper-slide-active {
  img {
    height: 250px;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/page/homepage/components/sm/good.vue